import React from 'react';
import PropTypes from 'prop-types';
import Accordion from 'relements/build/esm/ui/accordion';

import SubstoryHeader from '../SubstoryHeader';
import Node from '../Node';
import styles from './Substory.scss';

function Substory({
  id,
  onToggle,
  active,
  index,
  nodes,
  disabled,
  color,
  title,
  contextMenu,
  onNodeDragStart,
  onNodeDragEnd,
  onNodeDrop,
  onNodeChange,
  onSubstoryRename,
  activeNodeId,
  draggable,
  prefixComponent,
  postfixComponent,
  smartSkillsEnabled,
  highlightSkill,
  closeAddSkillDrawer,
  isSmartSkill,
}) {
  const [inputMode, setInputMode] = React.useState(false);
  const [highlight, setHightlight] = React.useState(highlightSkill);

  React.useEffect(() => {
    if (smartSkillsEnabled) {
      // eslint-disable-next-line no-unused-expressions
      setTimeout(() => {
        setHightlight(false);
      }, 3500);
    }
  }, [highlightSkill, smartSkillsEnabled]);

  const toggleInputMode = (isInput) => {
    setInputMode(isInput);
  };

  return (
    <div id={id} data-testid="listItemSkill">
      <Accordion.Item
        active={active}
        key={index}
        index={index}
        itemIndex={index}
        renderHeader={({ ExpandIcon }) => (
          <SubstoryHeader
            id={id}
            disabled={disabled}
            color={color}
            title={title}
            ExpandIcon={ExpandIcon}
            contextMenuItems={contextMenu}
            onSubstoryRename={onSubstoryRename}
            onDrop={onNodeDrop}
            smartSkillsEnabled={smartSkillsEnabled}
            inputMode={inputMode}
            setInputMode={(isInputActive) => toggleInputMode(isInputActive)}
            active={active}
            closeAddSkillDrawer={closeAddSkillDrawer}
            isSmartSkill={isSmartSkill}
          />
        )}
        onChange={onToggle}
        className={highlight && styles.substoryHighlight}
      >
        <div className={styles.substoryBody}>
          {prefixComponent}
          {nodes.map((node, i) => {
            return (
              <Node
                key={i}
                type={node.type}
                color={node.color}
                title={node.title}
                contextMenu={node.contextMenu}
                active={node.id === activeNodeId}
                disabled={disabled || !node.active}
                onDragStart={onNodeDragStart(node, i)}
                onDragEnd={onNodeDragEnd(node, i)}
                onClick={() => {
                  onNodeChange(node);
                }}
                draggable={draggable}
                smartSkillsEnabled={smartSkillsEnabled}
                closeAddSkillDrawer={closeAddSkillDrawer}
              />
            );
          })}
          {postfixComponent}
        </div>
      </Accordion.Item>
    </div>
  );
}

Substory.propTypes = {
  active: PropTypes.bool,
  activeNodeId: PropTypes.string,
  color: PropTypes.shape({
    primary: PropTypes.string,
  }),
  contextMenu: PropTypes.arrayOf(PropTypes.shape({})),
  disabled: PropTypes.bool,
  draggable: PropTypes.bool,
  id: PropTypes.string,
  index: PropTypes.number,
  nodes: PropTypes.arrayOf(PropTypes.shape({})),
  onNodeChange: PropTypes.func,
  onNodeDragEnd: PropTypes.func,
  onNodeDragStart: PropTypes.func,
  onNodeDrop: PropTypes.func,
  onSubstoryRename: PropTypes.func,
  onToggle: PropTypes.func,
  postfixComponent: PropTypes.node,
  prefixComponent: PropTypes.node,
  title: PropTypes.string,
};

Substory.defaultProps = {
  active: false,
  draggable: true,
  activeNodeId: '',
  color: {
    primary: '',
  },
  disabled: false,
  id: '',
  index: 0,
  onSubstoryRename: () => null,
  onNodeChange: () => null,
  onNodeDragEnd: () => null,
  onNodeDragStart: () => null,
  onNodeDrop: () => null,
  onToggle: () => null,
  title: '',
  contextMenu: [],
  nodes: [],
  prefixComponent: null,
  postfixComponent: null,
};

export default Substory;
